// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IGHE","option":"styles_option__10yOF","selected":"styles_selected__3tBoF"};